module.exports = __webpack_public_path__ + "img/login.87deb331.jpg";